import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import { VehicleMaintenanceSummaryList } from "./VehicleMaintenanceSummaryList";

export default {
  icon: BuildOutlinedIcon,
  list: VehicleMaintenanceSummaryList,
};
